export default __webpack_public_path__ + "static/121-6130e485c1f80881e96e4f766d002830.jpg";